module.exports = __webpack_public_path__ + "img/dubai.daeb73e2.png";